import {AbstractModel} from '../abstract-model';
import {ProductPriorityProduct} from './product-priority-product';

export class ProductPriority extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  updatedAt: Date | null = null;
  name: string | null = null;
  identifier: string | null = null;
  products: ProductPriorityProduct[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.products) {
      this.products = input.products.map((product: any) => new ProductPriorityProduct().deserialize(product))
    }

    return this;
  }

  override toString(): string {
    return this.name ?? '';
  }
}
